<!-- LICENSING Page Header-->
<h1 class="page-header"><i class="fa fa-server" aria-hidden="true"></i> LICENSING</h1>

<!-- Page -->
<div class="container-fluid">

  <!-- Header displaying if there is a valid License installed or not -->
  <h4>
    <em class="fa" [class.fa-check]="isCompiledLicenseValid()" [class.fa-warning]="!isCompiledLicenseValid()"></em>
    {{ getLicenseHeaderText() }} 
  </h4>

  <!-- View Compiled License Button-->
  <div class="add-op">
    <button type="button" class="btn btn-primary" (click)="viewCompiledLicenseClicked()">
      <em class="fa fa-pencil"></em> VIEW COMPILED LICENSE
    </button>
  </div>

  <!-- Available Hardware to License Table-->
  <div class="edgefinityHeader">LICENSING HARDWARE</div>
  <div>
    <table class="table tablesorter tablesorter-default table-hover table-bordered">
      <thead>
        <tr>
          <th>Hardware Type</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let hw of mAvailableHardware">
          <td>{{ hw.hardware_type }}</td>
          <td>{{ hw.hardware_value }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Install License / Options Buttons -->
  <input type="file" #licenseFile (change)="onFileChange($event)" style="display:none" />
  <div class="add-op">
    <!-- Install License Button -->
    <button type="button" class="btn btn-primary" (click)="showLicenseUploader()">
      <em class="fa fa-plus"></em> INSTALL LICENSE
    </button>

    <!-- Options Button/Menu -->
    <span>
      <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
          <em class="fa fa-th"></em>OPTIONS <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li [class.disabled]="!isSingleLicenseUiSelected()" (click)="viewLicenseClicked()">
            <a><em class="fa fa-pencil"></em> VIEW</a>
          </li>
          <li [class.disabled]="!isAnyLicenseUisSelected()" (click)="deleteLicenseClicked()">
            <a><em class="fa fa-remove"></em> DELETE</a>
          </li>
        </ul>
      </div>
    </span>
  </div>

  <!-- Installed Licenses Table -->
  <div class="edgefinityHeader">LICENSES INSTALLED</div>
  <div>
    <table class="table table-sorter tablesorter-default table-bordered table-hover">
      <thead>
        <tr>
          <th class="table-checkbox">
            <div class="checkbox checkbox-inline">
              <input type="checkbox" class="styled" [checked]="isAllLicenseUisSelected()" (change)="setAllLicenseUisSelected($event)">
              <label></label>
            </div>
          </th>
          <th>License Id</th>
          <th>Created</th>
          <th>Expires</th>
          <th>Is Valid?</th>
          <th>Is Valid for Server?</th>
          <th>Is Expired?</th>
        </tr>
      </thead>
      <tbody *ngFor="let ui of mLicenseUIs">
        <tr>
          <!-- Checkbox -->
          <td><input type="checkbox" [(ngModel)]="ui.mSelected"></td>
          <!-- License ID -->
          <td (click)="viewLicense(ui)">
            {{ui.mLicense.id}}
          </td>
          <!-- Issued Date -->
          <td (click)="viewLicense(ui)">
            {{ui.mLicense?.license_details?.issued_date}}
          </td>
          <!-- Expiration Date -->
          <td (click)="viewLicense(ui)">
            {{ui.mLicense?.license_details?.expiration_date}}
          </td>
          <!-- Is Valid -->
          <td (click)="viewLicense(ui)">
            <span [style.color]="ui.mLicense.is_valid ? 'green' : 'red'">
              {{ ui.getValidText() }}
            </span>
          </td>
          <!-- Is Valid for Server -->
          <td (click)="viewLicense(ui)">
            <span [style.color]="ui.mLicense.is_valid_for_server ? 'green' : 'red'">
              {{ ui.getValidForServerText() }}
            </span>
          </td>
          <!-- Is Expired -->
          <td (click)="viewLicense(ui)">
            <span [style.color]="ui.mLicense.is_expired ? 'red' : 'green'">
              {{ ui.getExpiredText() }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Verify Delete License Modal -->
<app-confirm-delete-dialog 
  (confirmEvent)="deleteConfirmed()"
  >
</app-confirm-delete-dialog>

<!-- Inform the user of an invalid license upload Modal -->
<div class="modal fade" id="invalidLicenseModal" role="dialog">
  <div class="modal-dialog modal-sm">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">Install License</h4>
      </div>
      <div class="modal-body">
        <p>This license is invalid. Cannot install.</p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- View License Dialog -->
<app-view-license-dialog
  [mLicense]="mLicenseToView"
  >
</app-view-license-dialog>

<!-- View Compiled License Dialog -->
<app-view-compiled-license-dialog
  [mLicenseInfo]="mCompiledLicense"
  >
</app-view-compiled-license-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>